
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diamondhead",
      function () {
        return require("private-next-pages/diamondhead/index.js");
      }
    ]);
  